/*
  Local wishlist — PDP mockup delta 3 (T15).

  The approved mockup puts a heart on every product card. The store has no
  wishlist app installed (judge.me / loox / swym / growave all return zero on
  both the live and the draft theme), so rather than dropping the control this
  keeps the list in localStorage: per browser, no account, no network.

  Delegated from the document so cards injected later — product
  recommendations, quick-add, the predictive-search panel — are covered without
  re-binding. Sections rendered by the theme editor re-run this file; the
  listener is registered once via the flag below.
*/
(function () {
  'use strict';

  var KEY = 'allmeat:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var ids = raw ? JSON.parse(raw) : [];
      return Array.isArray(ids) ? ids.map(String) : [];
    } catch (e) {
      // Private mode, a full quota or a corrupted value: the heart still
      // toggles visually for the session, it just does not survive a reload.
      return [];
    }
  }

  function write(ids) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (e) {
      /* nothing to do — see read() */
    }
  }

  function paint(root) {
    var saved = read();
    var buttons = (root || document).querySelectorAll('[data-am-wish]');
    for (var i = 0; i < buttons.length; i++) {
      var id = String(buttons[i].getAttribute('data-am-wish'));
      buttons[i].setAttribute('aria-pressed', saved.indexOf(id) === -1 ? 'false' : 'true');
    }
  }

  function toggle(button) {
    var id = String(button.getAttribute('data-am-wish'));
    var saved = read();
    var at = saved.indexOf(id);

    if (at === -1) {
      saved.push(id);
      button.setAttribute('aria-pressed', 'true');
    } else {
      saved.splice(at, 1);
      button.setAttribute('aria-pressed', 'false');
    }

    write(saved);
    document.dispatchEvent(
      new CustomEvent('allmeat:wishlist:change', { detail: { id: id, ids: saved } })
    );
  }

  if (!document.documentElement.dataset.amWishlistBound) {
    document.documentElement.dataset.amWishlistBound = '1';

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-am-wish]') : null;
      if (!button) return;
      // Cards wrap their media and title in links; without this a save would
      // navigate to the product page instead.
      event.preventDefault();
      event.stopPropagation();
      toggle(button);
    });

    // Another tab saved something — keep the hearts in agreement.
    window.addEventListener('storage', function (event) {
      if (event.key === KEY) { paint(document); paintBadge(); }
    });
  }

  /* T23/H10 — the header badge.

     The count is only knowable in the browser, so the badge ships hidden and is
     filled in here: on load, on every toggle, and when another tab writes the key.
     Kept in this file rather than the favourites page's, because the badge is on
     every route and the favourites page is one of them. */
  function paintBadge() {
    var n = read().length;
    var badges = document.querySelectorAll('[data-am-fav-badge]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].hidden = n === 0;
      badges[i].textContent = n > 99 ? '99+' : String(n);
    }
  }

  document.addEventListener('allmeat:wishlist:change', paintBadge);

  paint(document);
  paintBadge();
  document.addEventListener('shopify:section:load', function (event) {
    paint(event.target);
    paintBadge();
  });

  // The related-products block fetches its cards after load, and quick-add and
  // predictive search inject cards too. Those hearts arrive with the markup's
  // default aria-pressed="false", so a saved product came back unsaved after a
  // reload until they are repainted. Watch for inserted cards rather than
  // guessing at every injection point.
  if (!document.documentElement.dataset.amWishlistObserving && window.MutationObserver) {
    document.documentElement.dataset.amWishlistObserving = '1';

    var pending = null;
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-am-wish]') || node.querySelector('[data-am-wish]')) {
            // Coalesce: a single injection fires many records.
            if (pending) return;
            pending = window.requestAnimationFrame(function () {
              pending = null;
              paint(document);
            });
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
